import { createContext, useContext } from 'react';

import type { FavoriteType } from '../../services/favoritesApi';
import type { PendingAction } from '../../utils/pendingAction';

export type LoginActionLabel = 'favorite' | 'calendar' | 'review';

export interface SiteActions {
  isFavorite: (type: FavoriteType, id: string) => boolean;
  toggleFavorite: (type: FavoriteType, id: string) => void;
  /** True when signed in; otherwise opens the login prompt and remembers `action`. */
  requireLogin: (action: PendingAction, label: LoginActionLabel) => boolean;
  /** Share a site path such as /activity/slug. */
  share: (path: string, title?: string) => void;
}

/** Outside the provider (isolated component tests) every action is a no-op. */
const NO_ACTIONS: SiteActions = {
  isFavorite: () => false,
  toggleFavorite: () => {},
  requireLogin: () => false,
  share: () => {},
};

export const SiteActionsContext = createContext<SiteActions>(NO_ACTIONS);

export function useSiteActions(): SiteActions {
  return useContext(SiteActionsContext);
}
